module.exports = __webpack_public_path__ + "img/VerySatisfiedActive.a82a41db.png";